import { FC, useCallback, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

type Props = { namespace?: string };

export const ErrorFeedback: FC<Props> = ({ namespace = 'invitation.setPassword.error' }) => {
  const t = useTranslations(namespace);
  const { genericResponsiveValue } = useResponsiveStyle();
  const [loading, setLoading] = useState(false);

  const goToLogin = useCallback(() => {
    setLoading(true);
    window.location.href = Routes.Login;
  }, []);

  return (
    <Box>
      <Box
        display='flex'
        flexDirection='row'
        justifyContent='center'
        alignItems='center'
        minHeight='100vh'
        paddingX={genericResponsiveValue({
          breakPoints: { desktop: '20%' as never },
          defaultValue: 's',
        })}
      >
        <Box
          width='100%'
          display='flex'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          textAlign='center'
          flex='1'
        >
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='center'
            mb='xs'
            bg='error'
            p='xxs'
            borderRadius='100%'
          >
            <Svg name='cross' size='m' />
          </Box>
          <Typography
            variant='h1'
            color='primary/text'
            fontSize={genericResponsiveValue({
              breakPoints: { desktop: 50 as never },
              defaultValue: 'xxxl',
            })}
            lineHeight={genericResponsiveValue({
              breakPoints: { desktop: '60px' as never },
              defaultValue: 'xxxl',
            })}
            fontWeight='bold'
            mb={genericResponsiveValue({
              breakPoints: { desktop: 'xs' },
              defaultValue: 'xxs',
            })}
          >
            {t('title')}
          </Typography>
          <Typography variant='p1/bold' color='grey/light'>
            {t('description')}
          </Typography>
          <Button
            loading={loading}
            spinnerColor='white'
            variant='positive'
            mt='m'
            onClick={goToLogin}
          >
            {t('cta')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
